/**
 * Community Story-Reviews — 16 authentische Persona-Portraits.
 *
 * REGELN (V7 · Aug 2026):
 *   - JEDES Bild kommt EXAKT einmal vor (keine Wiederholungen auf der Plattform).
 *   - Persona-Details (Name, Alter, Beruf, Stadt) sind auf das Foto abgestimmt.
 *   - V7: Kaum noch exakte Guthaben-Beträge (nur wo story-essenziell, z. B.
 *     Lenas 68 € statt 620 €). Kernbotschaft: FuelX ist der richtige
 *     Ansprechpartner für ALLE Probleme rund ums Auto — in jeder Story anders
 *     formuliert („erste Adresse", „ein Kanal", „eine Stelle, die sich kümmert").
 *   - Mehrere Stories bewusst KURZ (2–3 Sätze), Länge variiert.
 *   - Ton bleibt ehrlich/unaufgeregt; Kritik in 4-Sterne-Stories bleibt.
 *
 * Spiegelt /app/backend/data/community_reviews.py (V12). ID + Photo + Namen
 * müssen zwischen beiden Dateien identisch sein — die Texte bewusst nicht.
 */

const AV = (slug) => `/avatars/authentic/${slug}.webp`;

export const COMMUNITY_STORIES = [
  // 1) Frau ~34, dunkles kurzes Haar, im Hotelzimmer mit Koffer
  {
    id: 'story-elias',
    name: 'Lena M.', age: 34, city: 'Berlin', role: 'Mutter in Vollzeit',
    rating: 5, photo: AV('lena-34-berlin'),
    usp: 'Fehlerdiagnose inklusive', savings: '68 € statt 620 €',
    category: 'werkstatt',
    text: 'Ich verstehe von Technik wenig — und fühle mich hier trotzdem nicht verloren. Bei der Motorleuchte wurde erst geprüft statt gleich getauscht: ein Sensor, 68 € statt 620 €. Seitdem gehe ich mit jeder Autofrage zuerst dorthin.',
  },
  // 2) Mann ~48, Glatze, graumelierter Bart, blaues Polo, am Alpsee
  {
    id: 'story-tolga',
    name: 'Tolga P.', age: 48, city: 'Frankfurt', role: 'Bankkaufmann',
    rating: 5, photo: AV('julian-41-frankfurt'),
    usp: 'Termine & Dokumente geregelt', savings: 'Alles an einem Ort',
    category: 'reise',
    text: 'TÜV, Ölwechsel, Unterlagen — ich muss an nichts mehr selbst denken. Es erinnert mich, ich buche, erledigt. Genau so stelle ich mir Service vor.',
  },
  // 3) Mann ~44, blaue Regenjacke, an Shell-Tankstelle mit Zapfpistole
  {
    id: 'story-kerstin',
    name: 'Carsten V.', age: 44, city: 'Karlsruhe', role: 'Grundschullehrer',
    rating: 5, photo: AV('kerstin-43-karlsruhe'),
    usp: 'Urlaube decken Auto-Services', savings: 'Familie profitiert',
    category: 'reise',
    text: 'Unsere Urlaube haben wir sowieso gebucht — darüber waren Prüfung und Reifenwechsel für beide Autos gleich mit abgedeckt. Und bei jeder Frage rund ums Auto gibt es jetzt eine Stelle, die sich kümmert. Meine Frau hat anfangs die Augen verdreht, mittlerweile bucht sie selbst.',
  },
  // 4) Frau ~41, langes braunes Haar, vor DEKRA-Prüfstelle mit TÜV-Bericht
  {
    id: 'story-ralf',
    name: 'Ramona P.', age: 41, city: 'Osnabrück', role: 'Speditions-Disponentin',
    rating: 5, photo: AV('ralf-53-osnabrueck'),
    usp: 'Versicherungs-Check inklusive', savings: 'Besserer Tarif ohne Portale',
    category: 'versicherung',
    text: 'Keine Lust auf Vergleichsportale — also lief mein Vertrag jahrelang unverändert. Den inklusiven Versicherungs-Check habe ich nebenbei angestoßen, und ein besseres Angebot kam von selbst. Inzwischen läuft bei mir alles rund ums Fahrzeug über diesen einen Kanal.',
  },
  // 5) Grauhaariger Mann ~58, am Bergsee mit offenem Kofferraum
  {
    id: 'story-thomas',
    name: 'Thomas K.', age: 58, city: 'Köln', role: 'Außendienst-Mitarbeiter',
    rating: 5, photo: AV('thomas-47-koeln'),
    usp: 'Reisen decken Auto-Services', savings: 'Prämie über Buchungen gedeckt',
    category: 'versicherung',
    text: 'Meine Frau plant die Reisen, ich kümmere mich um den Wagen — inzwischen läuft beides am selben Ort. Die Versicherungsprämie war über unsere Buchungen abgedeckt, und der Kostenüberblick zeigt mir, wo der Diesel steht. Ob das für jeden passt, muss jeder selbst rechnen. Bei uns passt es.',
  },
  // 6) Mann ~39, Glatze, rotblonder Bart, Küstenort mit offenem Kofferraum
  {
    id: 'story-jasmin',
    name: 'Jannik O.', age: 39, city: 'Essen', role: 'Erzieher in Elternzeit',
    rating: 4, photo: AV('jasmin-33-essen'),
    usp: 'Ehrliche Beratung', savings: 'Kein Verkaufsdruck',
    category: 'versicherung',
    text: 'Mir wurde offen gesagt, was sich bei unserer Fahrleistung lohnt und was nicht. So eine Beratung hatte ich vorher nirgends. Einzeln gebucht würden allein Diagnose und Pannenhilfe mehr kosten als die ganze Karte. Abzug fürs zähe Einrichten am Anfang.',
  },
  // 7) Mann ~59, grauer Schnurrbart, im Hotelzimmer mit Bergsee-Blick
  {
    id: 'story-franziska',
    name: 'Frank T.', age: 59, city: 'Leipzig', role: 'Versicherungskaufmann',
    rating: 5, photo: AV('franziska-31-leipzig'),
    usp: 'Schadenfoto-Check', savings: 'Einschätzung traf zu',
    category: 'werkstatt',
    text: 'Für eine Parkplatzdelle wollte ich keinen Kaskofall aufmachen. Fotos hochgeladen, die Ersteinschätzung war realistisch und die Abwicklung sauber. Ich arbeite selbst in der Versicherungsbranche — hier gibt es wenig zu bemängeln, und das sage ich selten.',
  },
  // 8) Mann ~40, Brille, blond, vor TÜV Rheinland Prüfstelle Köln
  {
    id: 'story-bernd',
    name: 'Bernd K.', age: 42, city: 'Hamburg', role: 'Softwarearchitekt',
    rating: 4, photo: AV('bernd-39-hamburg-v2'),
    usp: 'Alles an einem Ort', savings: '190 € beim Reifenkauf',
    category: 'werkstatt',
    text: 'Gleiche Reifen, gleicher Händler, 190 € weniger. Belege und Kosten liegen jetzt an einem Ort. Auswahl an Marken ist ausbaufähig. Vier Sterne.',
  },
  // 9) Junge Frau ~29, weiße Bluse, Mittelmeer-Hafenpromenade
  {
    id: 'story-sabine',
    name: 'Selin R.', age: 29, city: 'München', role: 'Flottenmanagerin',
    rating: 5, photo: AV('sabine-52-muenchen'),
    usp: '18 Fahrzeuge zentral', savings: 'Weniger Verwaltung',
    category: 'reise',
    text: 'Termine, Wartungen, Buchungen — für unseren Fuhrpark läuft alles an einer Stelle. Wenn irgendwo etwas klemmt, gibt es einen Ansprechpartner statt fünf Hotlines. Das spart mir mehr als jede Einzelaktion.',
  },
  // 10) Frau ~58, graues kurzes Haar, Brille, weinrote Jacke, vor ATU-Meisterwerkstatt
  {
    id: 'story-andreas',
    name: 'Andrea B.', age: 58, city: 'Augsburg', role: 'Sanitär-Meisterin',
    rating: 4, photo: AV('andreas-52-augsburg'),
    usp: 'Pannen-Soforthilfe', savings: 'Wagen lief nach 30 Min.',
    category: 'versicherung',
    text: 'Für uns zählt, dass die Wagen laufen. Die Panne neulich war über die Soforthilfe nach einer halben Stunde erledigt, Steuer und Prüfungen decken wir über die Montage-Übernachtungen der Kollegen. Die Belegübersicht dürfte besser sortiert sein.',
  },
  // 11) Junger Mann ~27, lockiges Haar, dunkler Bart, orange Kapuze, vor DEKRA
  {
    id: 'story-kevin',
    name: 'Kevin M.', age: 27, city: 'Magdeburg', role: 'Fachinformatiker',
    rating: 5, photo: AV('kevin-24-magdeburg'),
    usp: 'Hilfe fürs erste Auto', savings: 'Einer, der weiterweiß',
    category: 'werkstatt',
    text: 'Erstes Auto, wenig Ahnung. Egal was ist — ich frage einfach dort nach und bekomme es in normalen Worten erklärt. Mehr brauche ich gar nicht.',
  },
  // 12) Mann ~45, dunkles Haar mit grauen Strähnen, blaues Hemd, Cadillac Hotel Miami
  {
    id: 'story-peter',
    name: 'Peter S.', age: 46, city: 'Nürnberg', role: 'Elektromeister',
    rating: 5, photo: AV('peter-46-nuernberg-v2'),
    usp: 'Wartung unkompliziert', savings: 'Sauber abgerechnet',
    category: 'werkstatt',
    text: 'Ich bin Handwerker und vergleiche Rechnungen. Ölservice und Bremsen liefen über das Reiseguthaben, die Abrechnung war nachvollziehbar. Preis und Leistung stehen hier in einem Verhältnis, das ich selten sehe. Keine Einwände.',
  },
  // 13) Mann ~45, blond, Brille, dunkelblauer Zip-Pullover, Atlantic Hotel Kiel
  {
    id: 'story-malte',
    name: 'Malte T.', age: 45, city: 'Kiel', role: 'Bereichsleiter Reederei',
    rating: 5, photo: AV('malte-45-kiel'),
    usp: 'Auto-Verkauf-Service', savings: 'Deutlich über Händlerangebot',
    category: 'auto-verkauf',
    text: 'Der Händler bot deutlich unter Marktwert. Über den Verkaufs-Service wurden Bewertung, Inserat und Vertrag komplett übernommen — nach acht Tagen war der Kombi verkauft, klar über dem Händlerangebot. Gut organisiert, ohne dass ich hinterher sein musste.',
  },
  // 14) Frau ~45, dunkles Haar, auf Hotelbalkon mit Bergsee-Blick
  {
    id: 'story-anke',
    name: 'Anke G.', age: 45, city: 'Lübeck', role: 'Physiotherapeutin',
    rating: 5, photo: AV('anke-45-luebeck-v4'),
    usp: 'Fester Kostenvoranschlag', savings: 'Rechnung wie angekündigt',
    category: 'werkstatt',
    text: 'Ich verhandle ungern in Werkstätten. Diesmal stand jede Position vorher fest, und die Rechnung entsprach genau der Ansage. Seitdem ist das meine erste Adresse, wenn am Auto etwas ansteht.',
  },
  // 15) Frau ~36, langes braunes Haar, im Hotelzimmer mit Stadtblick
  {
    id: 'story-silke',
    name: 'Sarah L.', age: 36, city: 'Hannover', role: 'Stationsleitung Klinik',
    rating: 5, photo: AV('sarah-36-hannover'),
    usp: 'Reisen decken die Prämie', savings: 'Angenehm einfach',
    category: 'reise',
    text: 'Im Schichtdienst habe ich für komplizierte Sparmodelle keine Geduld. Zwei Reisen gebucht, die Jahresprämie war darüber abgedeckt — mehr musste ich nicht tun.',
  },
  // 16) Frau ~40, rotes lockiges Haar, weißer Rollkragen, TÜV Rheinland Dortmund
  {
    id: 'story-renate',
    name: 'Renate B.', age: 40, city: 'Dortmund', role: 'Gymnasiallehrerin',
    rating: 4, photo: AV('renate-57-dortmund-v2'),
    usp: 'Geduldiger Support', savings: 'Ehrliche Antworten',
    category: 'werkstatt',
    text: 'Ich habe das Prinzip anfangs nicht verstanden und dem Support viele Fragen gestellt. Die Antworten waren geduldig und ehrlich — auch zu dem, was die Karte nicht kann. Der Einstieg war holprig, deshalb vier Sterne. Inzwischen frage ich bei Autofragen zuerst dort.',
  },
];

/** Getter: gibt bis zu N Community-Stories zurück (max 16 einzigartige). */
export function getCommunityStories(limit = 16) {
  return COMMUNITY_STORIES.slice(0, Math.min(limit, COMMUNITY_STORIES.length));
}
